import React from 'react'
import CardChart from '../Components/CardChart'
import { Skeleton, Table, TableBody, TableCell, TableRow } from '@mui/material'
const YourStrengthsOrFocusOn = ({ icon, title, bgColor, border, isLoading, data }) => {
  return (
    <CardChart icon={icon} title={title} bgColor={bgColor} border={border}>
      <Table>
        <TableBody>
          {isLoading
            ? Array.from({ length: 5 }).map((_, i) => (
                <TableRow key={i}>
                  <TableCell>
                    <Skeleton width={100} height={20} />
                  </TableCell>
                  <TableCell className='flex gap-2 items-center '>
                    <Skeleton width={100} height={20} />
                    <Skeleton width={100} height={20} />
                  </TableCell>
                </TableRow>
              ))
            : data.map((item, i) => (
                <TableRow key={i} className='text-sm'>
                  <TableCell>{item.name}</TableCell>
                  <TableCell align='right'>{item?.level?.level || '-'}</TableCell>
                </TableRow>
              ))}
        </TableBody>
      </Table>
    </CardChart>
  )
}

export default YourStrengthsOrFocusOn
